import PropTypes from 'prop-types';


// eslint-disable-next-line import/prefer-default-export
export const orderType = PropTypes.shape({
    id: PropTypes.number.isRequired,
    article_rows: PropTypes.arrayOf(
        PropTypes.shape({
            articleName: PropTypes.string,
            articleCode: PropTypes.string,
        }),
    ),
    client_name: PropTypes.string,
    status_display: PropTypes.string,
    full_number: PropTypes.string,
    order_date: PropTypes.string,
    delivery_date: PropTypes.string,
    article_code: PropTypes.string,
    info: PropTypes.string,
    width: PropTypes.string,
    fastening: PropTypes.string,
    extras: PropTypes.string,
    transport: PropTypes.string,
    absolute_url: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    is_quality_check_required: PropTypes.bool.isRequired,
    is_loading: PropTypes.bool.isRequired,
    is_checked: PropTypes.bool.isRequired,
    local_waybill_path: PropTypes.string,
    cmr_waybill_path: PropTypes.string,
    customer_number: PropTypes.string,
});



// WEBPACK FOOTER //
// ./src/propTypes/orders.js